// Co-located translations for the Research tab
// Registered dynamically when component loads
const researchTranslations = {
  "en": {
    "tabs.research": "Research",
    "research.title": "Market Research & Reference Data",
    "research.subtitle": "Reference data for German real estate investment decisions",

    "research.taxEntities": "Tax Entity Comparison",
    "research.taxEntitiesIntro": "Germany offers 5 common ownership structures for rental properties, each with different tax treatment. Choose based on your income level, number of properties, and long-term strategy.",
    "research.entity": "Entity",
    "research.effectiveTaxRate": "Effective Tax Rate",
    "research.gewerbesteuer": "Trade Tax",
    "research.spekulationsfrist": "Speculation Period",
    "research.lossOffset": "Loss Offset",
    "research.yes": "Yes",
    "research.no": "No",
    "research.none": "None",
    "research.yearsHolding": "{years} years",
    "research.fullOffset": "Against all income",
    "research.rentalOnly": "Rental income only",
    "research.personalTaxNote": "14-45% progressive (income-dependent)",
    "research.gmbhTaxNote": "~30% corporate (KSt + GewSt)",
    "research.immoGmbhTaxNote": "~15.8% (KSt + SolZ, no GewSt)",
    "research.kgTaxNote": "14-45% progressive (pass-through)",
    "research.stiftungTaxNote": "~15.8% (KSt + SolZ)",
    "research.bestFor": "Best for",
    "research.privateBest": "1-2 properties, high income, loss offset against salary",
    "research.gmbhBest": "Multiple properties, reinvestment focus, liability protection",
    "research.immoGmbhBest": "Pure rental operations, lowest tax rate, long-term hold",
    "research.kgBest": "Family asset transfer, loss offset + Spekulationsfrist",
    "research.stiftungBest": "Large portfolios, succession planning, asset protection",
    "research.taxDisclaimer": "Tax rates are approximate. Consult a Steuerberater for your specific situation.",

    "research.acquisitionCosts": "Acquisition Costs by Bundesland",
    "research.acquisitionIntro": "Purchase costs vary significantly across German states. Property transfer tax alone ranges from 3.5% (Bavaria) to 6.5% (Brandenburg, NRW, Schleswig-Holstein, Saarland).",
    "research.bundesland": "Bundesland",
    "research.transferTax": "Transfer Tax",
    "research.notary": "Notary",
    "research.landRegistry": "Land Registry",
    "research.broker": "Broker (Buyer)",
    "research.totalCosts": "Total",
    "research.examplePrice": "Example: €{price}k purchase",
    "research.cheapest": "Cheapest",
    "research.mostExpensive": "Most expensive",
    "research.selectPrice": "Purchase price for calculation",

    "research.rentalMarket": "Rental Market Data (24 Cities)",
    "research.rentalMarketIntro": "Current rental yields vary dramatically by city. Munich has the lowest yields but strongest appreciation; cities like Leipzig or Dortmund offer higher initial yields with more vacancy risk.",
    "research.city": "City",
    "research.rentPerSqm": "Rent (€/m²)",
    "research.pricePerSqm": "Price (€/m²)",
    "research.grossYield": "Gross Yield",
    "research.vacancy": "Vacancy",
    "research.rentCap": "Rent Cap",
    "research.sortBy": "Sort by",
    "research.sortYield": "Gross Yield",
    "research.sortRent": "Rent",
    "research.sortPrice": "Price",
    "research.sortVacancy": "Vacancy",
    "research.active": "Active",

    "research.depreciation": "Depreciation (AfA) Guide",
    "research.depreciationIntro": "Building depreciation reduces taxable rental income. Only the building portion is depreciable — land never depreciates. Three methods exist depending on building age and type.",
    "research.afaMethod": "Method",
    "research.afaRate": "Rate",
    "research.eligibility": "Eligibility",
    "research.standardAfA": "Standard (Linear)",
    "research.degressiveAfA": "Degressive",
    "research.denkmalAfA": "Denkmalschutz (§7i)",
    "research.pre1925Rate": "2.5% / year",
    "research.post1925Rate": "2.0% / year",
    "research.post2022Rate": "3.0% / year",
    "research.degressiveRate": "5.0% of residual / year",
    "research.denkmalRate": "9% (yr 1-8), 7% (yr 9-12)",
    "research.standardEligibility": "All residential buildings",
    "research.degressiveEligibility": "New builds completed after 30.09.2023",
    "research.denkmalEligibility": "Certified historic buildings (renovation costs only)",
    "research.landSplit": "Land/Building Split (Bodenrichtwert)",
    "research.landSplitIntro": "The land share is NOT depreciable. In expensive cities, land can be 50-80% of the purchase price.",
    "research.location": "Location",
    "research.landShareRange": "Typical Land Share",
    "research.depreciationExample": "Example",
    "research.depreciationExampleText": "€300k purchase, 30% land = €210k building value × 2% AfA = €4,200/year tax deduction",
    "research.renovationRules": "Renovation: 15% Rule",
    "research.renovationRulesText": "If renovation costs exceed 15% of building acquisition cost within 3 years, they must be capitalized and depreciated (anschaffungsnahe Aufwendungen), not expensed immediately.",

    "research.operatingCosts": "Operating Cost Benchmarks",
    "research.operatingIntro": "Typical annual operating costs for German rental property, by building age.",
    "research.buildingAge": "Building Age",
    "research.maintenanceRange": "Maintenance (% of value/year)",
    "research.majorCapex": "Major Capital Expenditures",
    "research.capexItem": "Item",
    "research.typicalCost": "Typical Cost",
    "research.interval": "Lifecycle",
    "research.disclaimer": "For entertainment purposes only. Not investment advice. Consult professional advisors for actual investment decisions."
  },
  "de": {
    "tabs.research": "Recherche",
    "research.title": "Marktrecherche & Referenzdaten",
    "research.subtitle": "Referenzdaten für deutsche Immobilien-Investitionsentscheidungen",

    "research.taxEntities": "Steuerliche Rechtsformen",
    "research.taxEntitiesIntro": "Deutschland bietet 5 gängige Rechtsformen für Mietimmobilien, jeweils mit unterschiedlicher steuerlicher Behandlung. Die Wahl hängt vom Einkommensniveau, der Anzahl der Immobilien und der langfristigen Strategie ab.",
    "research.entity": "Rechtsform",
    "research.effectiveTaxRate": "Effektiver Steuersatz",
    "research.gewerbesteuer": "Gewerbesteuer",
    "research.spekulationsfrist": "Spekulationsfrist",
    "research.lossOffset": "Verlustverrechnung",
    "research.yes": "Ja",
    "research.no": "Nein",
    "research.none": "Keine",
    "research.yearsHolding": "{years} Jahre",
    "research.fullOffset": "Mit allen Einkünften",
    "research.rentalOnly": "Nur Mieteinkünfte",
    "research.personalTaxNote": "14-45% progressiv (einkommensabhängig)",
    "research.gmbhTaxNote": "~30% Körperschaftsteuer (KSt + GewSt)",
    "research.immoGmbhTaxNote": "~15,8% (KSt + SolZ, keine GewSt)",
    "research.kgTaxNote": "14-45% progressiv (transparent)",
    "research.stiftungTaxNote": "~15,8% (KSt + SolZ)",
    "research.bestFor": "Geeignet für",
    "research.privateBest": "1-2 Immobilien, hohes Einkommen, Verlustverrechnung mit Gehalt",
    "research.gmbhBest": "Mehrere Immobilien, Reinvestitionsfokus, Haftungsschutz",
    "research.immoGmbhBest": "Reine Vermietung, niedrigster Steuersatz, langfristiges Halten",
    "research.kgBest": "Familiäre Vermögensübertragung, Verlustverrechnung + Spekulationsfrist",
    "research.stiftungBest": "Große Portfolios, Nachfolgeplanung, Vermögensschutz",
    "research.taxDisclaimer": "Steuersätze sind Näherungswerte. Konsultieren Sie einen Steuerberater für Ihre individuelle Situation.",

    "research.acquisitionCosts": "Kaufnebenkosten nach Bundesland",
    "research.acquisitionIntro": "Kaufnebenkosten variieren erheblich zwischen den Bundesländern. Allein die Grunderwerbsteuer reicht von 3,5% (Bayern) bis 6,5% (Brandenburg, NRW, Schleswig-Holstein, Saarland).",
    "research.bundesland": "Bundesland",
    "research.transferTax": "GrErwSt",
    "research.notary": "Notar",
    "research.landRegistry": "Grundbuch",
    "research.broker": "Makler (Käufer)",
    "research.totalCosts": "Gesamt",
    "research.examplePrice": "Beispiel: €{price}k Kaufpreis",
    "research.cheapest": "Günstigster",
    "research.mostExpensive": "Teuerster",
    "research.selectPrice": "Kaufpreis für Berechnung",

    "research.rentalMarket": "Mietmarktdaten (24 Städte)",
    "research.rentalMarketIntro": "Die Mietrenditen variieren stark nach Stadt. München hat die niedrigsten Renditen aber stärkste Wertsteigerung; Städte wie Leipzig oder Dortmund bieten höhere Anfangsrenditen bei mehr Leerstandsrisiko.",
    "research.city": "Stadt",
    "research.rentPerSqm": "Miete (€/m²)",
    "research.pricePerSqm": "Preis (€/m²)",
    "research.grossYield": "Bruttorendite",
    "research.vacancy": "Leerstand",
    "research.rentCap": "Mietpreisbremse",
    "research.sortBy": "Sortieren nach",
    "research.sortYield": "Bruttorendite",
    "research.sortRent": "Miete",
    "research.sortPrice": "Preis",
    "research.sortVacancy": "Leerstand",
    "research.active": "Aktiv",

    "research.depreciation": "Abschreibung (AfA) Leitfaden",
    "research.depreciationIntro": "Gebäudeabschreibung reduziert das zu versteuernde Mieteinkommen. Nur der Gebäudeanteil ist abschreibbar — Grund und Boden nie. Drei Methoden stehen je nach Baualter und Gebäudetyp zur Verfügung.",
    "research.afaMethod": "Methode",
    "research.afaRate": "Satz",
    "research.eligibility": "Voraussetzungen",
    "research.standardAfA": "Standard (Linear)",
    "research.degressiveAfA": "Degressiv",
    "research.denkmalAfA": "Denkmalschutz (§7i)",
    "research.pre1925Rate": "2,5% / Jahr",
    "research.post1925Rate": "2,0% / Jahr",
    "research.post2022Rate": "3,0% / Jahr",
    "research.degressiveRate": "5,0% vom Restwert / Jahr",
    "research.denkmalRate": "9% (J. 1-8), 7% (J. 9-12)",
    "research.standardEligibility": "Alle Wohngebäude",
    "research.degressiveEligibility": "Neubauten fertiggestellt nach 30.09.2023",
    "research.denkmalEligibility": "Zertifizierte Baudenkmäler (nur Sanierungskosten)",
    "research.landSplit": "Grund/Gebäude-Aufteilung (Bodenrichtwert)",
    "research.landSplitIntro": "Der Grundstücksanteil ist NICHT abschreibbar. In teuren Städten kann der Grundstücksanteil 50-80% des Kaufpreises betragen.",
    "research.location": "Lage",
    "research.landShareRange": "Typischer Grundstücksanteil",
    "research.depreciationExample": "Beispiel",
    "research.depreciationExampleText": "€300k Kauf, 30% Grund = €210k Gebäudewert × 2% AfA = €4.200/Jahr Steuerabzug",
    "research.renovationRules": "Renovierung: 15%-Regel",
    "research.renovationRulesText": "Übersteigen Renovierungskosten innerhalb von 3 Jahren 15% der Gebäude-Anschaffungskosten, müssen sie aktiviert und abgeschrieben werden (anschaffungsnahe Aufwendungen).",

    "research.operatingCosts": "Betriebskosten-Richtwerte",
    "research.operatingIntro": "Typische jährliche Betriebskosten für deutsche Mietimmobilien, nach Gebäudealter.",
    "research.buildingAge": "Gebäudealter",
    "research.maintenanceRange": "Instandhaltung (% vom Wert/Jahr)",
    "research.majorCapex": "Größere Investitionen",
    "research.capexItem": "Maßnahme",
    "research.typicalCost": "Typische Kosten",
    "research.interval": "Lebenszyklus",
    "research.disclaimer": "Nur zu Unterhaltungszwecken. Keine Anlageberatung. Konsultieren Sie professionelle Berater für tatsächliche Investitionsentscheidungen."
  }
};

export default researchTranslations;
